module.exports = __webpack_public_path__ + "static/media/fractions-select.fc1b91d7.svg";